<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div class="p-3">
    <div class="row mt-2">
      Depots<br/>
      <ul>
        <li>New Depot</li>
        <li>Edit Depot</li>
        <li>View Depot Details (graphing on dash)</li>
      </ul>
    </div>
  </div>
</div>
